import { ErrorCodes } from './Errors';

enum URLs {
  Base = '/',
  CustomerDetails = '/customer-details',
  OptionsLoading = '/options-loading',
  EmailVerification = '/email-verification',
  ChooseYourPlan = '/choose-your-plan',
  PurchaseAmountPending = '/purchase-amount-pending',
  PurchaseAmountNotConfirmed = '/purchase-amount-not-confirmed',
  PaymentDetails = '/payment-details',
  Agreement = '/agreement',
  Review = '/review',
  ProcessingPayment = '/processing-payment',
  PostChargeFailed = '/post-charge-failed',
  Thanks = '/thanks',
  EstimateThankYou = '/estimate-thank-you',
  Info = '/info',
  Document = '/document',
  CustomerVerification = '/verification',
  CustomerVerified = '/verified',
  Message = '/message',
  Decline = '/decline',
  DebitCardValidation = '/debit-card-validation',
  LinkExpired = '/link-expired',
  CreditFreeze = '/credit-freeze',
  Evnoia = '/evnoia',
  Intro = '/intro',
}

export enum InfoURLs {
  ArbitrationProvision = '/arbitration-provision',
  PrivacyPolicy = '/privacy-policy',
  ElectronicContact = '/electronic-contact',
  RatesAndTerms = '/ratesAndTerms',
  CreditReportAuthAndApplicationSharing = '/credit-report-auth-and-application-sharing',
  TermsAndConditions = '/terms-and-conditions',
  TermsOfUse = '/terms-of-use',
}

export enum MessageURLs {
  TechnicalError = '/technical-error',
  SessionExpiredByUI = '/session-expired-by-ui',
  InvalidLink = '/invalid-link',
}

export type SuccessfulExternalMessagesRoutes = 'customer-verified-external';
export type ErrorExternalMessagesRoutes = 'purchase-amount-limit' | 'link-creation-error';
export type PageRedirectExternalMessagesRoutes = SuccessfulExternalMessagesRoutes;
export type ExternalMessagesRoutes = SuccessfulExternalMessagesRoutes | ErrorExternalMessagesRoutes;

export const externalMessagesRoutes: ExternalMessagesRoutes[] = [
  'purchase-amount-limit',
  'customer-verified-external',
  'link-creation-error',
];

export interface ErrorRouteMapping {
  eventName: string;
  errorCode: ErrorCodes;
}

export const RouteToErrorMapping: Record<ErrorExternalMessagesRoutes, ErrorRouteMapping> = {
  'purchase-amount-limit': {
    eventName: 'purchaseAmountLimit',
    errorCode: ErrorCodes.PurchaseAmountLimit,
  },
  'link-creation-error': {
    eventName: 'linkCreationError',
    errorCode: ErrorCodes.LinkCreationError,
  },
};

export const isErrorExternalMessageRoute = (token: unknown): token is ErrorExternalMessagesRoutes =>
  typeof token === 'string' && Object.prototype.hasOwnProperty.call(RouteToErrorMapping, token);

export const RouteToUrlMapping: Record<PageRedirectExternalMessagesRoutes, string> = {
  'customer-verified-external': URLs.CustomerVerified,
};

export default URLs;
